import Backdrop from '@mui/material/Backdrop';
import { alpha } from '@mui/material/styles';
import './globalLoadingStyles.css';
import CircularProgress from '@mui/material/CircularProgress';

export function LoadingOverlay() {
  return (
    <Backdrop
      sx={{
        backgroundColor: (theme) => alpha(theme.palette.common.white, 0.9),
        position: 'absolute',
        top: 0,
        left: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: (theme) => theme.zIndex.drawer + 1,
      }}
      open={true}
    >
      <CircularProgress />
    </Backdrop>
  );
}
